import { z } from "zod";

import { TitleWithIconSchema } from "@shared/content-types/schemas/pageHero.schema";
import { MetaSchema } from "@shared/content-types/schemas/pagination.schema";
import { SeoSchema } from "@shared/content-types/schemas/seo.schema";

import { ArticleShema } from "@/_pages/article/model/schemas";

export const NewsPageSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  titleWithIcon: TitleWithIconSchema,
  seo: SeoSchema.optional().nullable(),
});

export const NewsPageDtoSchema = z.object({
  data: NewsPageSchema,
});

export const NewsArticlesDtoSchema = z.object({
  data: z.array(ArticleShema).min(0),
  meta: MetaSchema,
});
